import { useContext } from "react";
import { AppContext } from "../Theme";
import Sidebar from "../components/sidebar/sidebar";
import Navbar from "../components/navbar/navbar";
import Team from "../components/team/team";
import "../main.css";

export default function TeamPage() {
	const { darkmode, toggleMode } = useContext(AppContext);

	return (
		<>
			<div className="sidebar-component">
				<Sidebar mode={darkmode} toggleMode={toggleMode} />
			</div>
			<div className="navbar-component">
				<Navbar mode={darkmode} username="Nexcare" />
			</div>
			<Team mode={darkmode} />
		</>
	);
}
